export const colors = {
    white: "#FFFFFF",
    black: "#000000",

    brand: {
        default: "#8C1837",
        dark: "#5A0F22"
    },

    background: {
        default: "#FDFCF8",
        secondary: "#19140E"
    },

}